import React from 'react'
import PropTypes from 'prop-types'

const UnmutedIcon = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.17188" y="0.75" width="38.5" height="38.5" rx="19.25" fill="#151515" fillOpacity="0.6" stroke="currentColor" strokeWidth="1.5" />
    <path d="M20.7076 12L14.9933 16.5714H10.4219V23.4286H14.9933L20.7076 28V12Z" fill="currentColor" stroke="currentColor" strokeWidth="1.14286" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24.4219 15.9541C25.4931 17.0257 26.0949 18.4789 26.0949 19.9941C26.0949 21.5093 25.4931 22.9625 24.4219 24.0341" stroke="currentColor" strokeWidth="1.14286" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M28.4219 14C29.7025 15.5915 30.4219 17.7497 30.4219 20C30.4219 22.2503 29.7025 24.4085 28.4219 26" stroke="currentColor" strokeWidth="1.14286" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

UnmutedIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

UnmutedIcon.defaultProps = {
  width: 41,
  height: 40,
  title: 'Menu',
}

export default UnmutedIcon
